<script>
import { h } from 'vue';
import lzString from 'lz-string';
import InjectPlugins from '@/components/Report/Components/inject-plugins';

let ticket = Number.MIN_SAFE_INTEGER;

export default {
  name: 'Loader',
  props: {
    component: {
      type: Object,
      default: () => null,
    },
    loader: {
      type: Object,
      default: () => null,
    },
    fallback: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      ticket: null,
      error: false,
      loading: true,
      data: null,
      params: this.$route.params.urlQuery 
        ? JSON.parse(lzString.decompressFromEncodedURIComponent(this.$route.params.urlQuery)) 
        : {},
    };
  },
  computed: {
    watchParams() {
      return {
        component: this.component,
        loader: this.loader,
        fallback: this.fallback,
      };
    },
  },
  watch: {
    watchParams: {
      immediate: true,
      handler() {
        this.data = null;
        this.fetch();    
      },
    },
  },
  // mounted() {
  //   this.fetch();
  // },
  mixins: [
    InjectPlugins,
  ],
  methods: {
    fetch() {
      if (this.data) {
        return;
      }

      this.loading = true;
      this.error = false;

      ticket += 1;
      this.ticket = ticket;

      if (this.component?.fetch) {
        this.params = this.$route.params.urlQuery 
          ? JSON.parse(lzString.decompressFromEncodedURIComponent(this.$route.params.urlQuery)) 
          : {};
        this.component.fetch(this, this.params)
          .then((data) => {
            if(this.ticket === ticket) {
              this.loading = false;
              this.data = data;
            }
          })
          .catch((err) => {
            if(this.ticket === ticket) {
              this.error = err;
            }
          });
      }
    },
  },
  render() {
    if (this.fallback && this.error) {
      return h(this.fallback, {
        // ctx: this,
        error: this.error,
      });
    }

    if (this.loader && this.loading) {
      return h(this.loader, { name: this.component?.name  });
    }

    return h(this.component, {
      // ctx: this,
      fetchedData: this.data,
      passedParams: this.params,
    });
  },
};

</script>